import React, { useEffect } from "react";
import { default as Text } from "/application/webos/webos_tv_emulator/Text";
import { default as List } from "/application/webos/webos_tv_emulator/List";
import { default as Icons } from "/application/webos/webos_tv_emulator/Icons";
import { default as Image } from "/application/webos/webos_tv_emulator/Image";
import { default as Table } from "/application/webos/webos_tv_emulator/Table";

export default function SingleScreenList({
  content,
  singleScreenStep,
  setIsSingleStepScreen,
}) {
  useEffect(() => {
    return () => {
      setIsSingleStepScreen(true);
    };
  }, []);
  return (
    <div
      className="single-screen-list"
      style={{
        margin: content.component_margin ? content.component_margin : "0",
      }}
    >
      {content.content[singleScreenStep].step_num ? (
        <p
          id="big-number"
          style={{
            fontSize: "120px",
            margin: "0",
            fontFamily: "LG_Smart_Bold",
            color: "#c20839",
          }}
        >
          {content.content[singleScreenStep].step_num}
        </p>
      ) : null}
      <div
        id="ssl-div"
        style={{
          color: "rgb(210,35,78)",
          gridColumnStart: "second",
          gridRowStart: "margin",
          marginTop: "50px",
          fontFamily: "LG_Smart_Bold",
        }}
      >
        {content.content
          ? content.content[singleScreenStep].step_content.map((obj) => {
              switch (obj.component) {
                case "text":
                  return <Text content={obj} id="single" />;
                case "list":
                  return <List content={obj} />;
                case "icons":
                  return <Icons content={obj} />;
                case "image":
                  return <Image content={obj} />;
                case "table":
                  return <Table content={obj} />;
                default:
                  return null;
              }
            })
          : null}
      </div>
    </div>
  );
}
